﻿import { fieldsProxy } from "@serenity-is/corelib";
import { CommentsRow } from "../Default/CommentsRow";
import { DocumentRevision } from "./Default.DocumentRevision";

export interface DocumentsRow {
    DocumentId?: number;
    StatusId?: number;
    TypeId?: number;
    DataClassId?: number;
    ProjectManagerId?: number;
    ProjectManager2Id?: number;
    ProjectManager?: string;
    ProjectManager2?: string;
    ProjectManagerUserId?: number;
    ProjectManager2UserId?: number;
    WBSElementId?: number;
    WbsElementShortNo?: string;
    WBSElementDescription?: string;
    UsageTypeId?: number;
    BusinessUnitId?: number;
    ContactUnitId?: number;
    ActualVersionId?: number;
    MeetingId?: number;
    File?: string;
    Filename?: string;
    FileExtension?: string;
    IsProjectOnlyDocument?: boolean;
    IsWBSOnlyDocument?: boolean;
    IsTaskDocument?: boolean;
    IsWBSAndTaskDocument?: boolean;
    Description?: string;
    RevisionInfo?: string;
    CreatedBy?: string;
    CreatedOn?: string;
    ModifiedBy?: string;
    ModifiedOn?: string;
    ReleaseDate?: string;
    ProjectTypeId?: number;
    ProjectStatusId?: number;
    ProjectRevision?: string;
    ProjectContractNo?: string;
    ProjectCustomerId?: number;
    ProjectCustomerName?: string;
    ProjectKeyword?: string;
    Status?: string;
    StatusMainStatus?: string;
    Type?: string;
    DataClassName?: string;
    ExistsOnDisk?: boolean;
    AutoRename?: boolean;
    LinkedDocumentId?: number;
    LinkedDocumentFile?: string;
    IsLink?: boolean;
    OlderVersions?: DocumentRevision[];
    CommentsList?: CommentsRow[];
    Folder?: string;
    ProjectId?: number;
    TaskId?: number;
}

export abstract class DocumentsRow {
    static readonly idProperty = 'DocumentId';
    static readonly localTextPrefix = 'Default.Documents';
    static readonly deletePermission = 'Projects:General';
    static readonly insertPermission = 'Projects:General';
    static readonly readPermission = 'Projects:General';
    static readonly updatePermission = 'Projects:General';

    static readonly Fields = fieldsProxy<DocumentsRow>();
}